import { useMemo } from "react";
import CalendarIcon from "@icons/CalendarIcon.svg?react";
import { SvgImageSwap } from "../../display-items/SVGIcon";
import { durationToEvent, eventActive } from "../../../helpers/helpers";
import { formatTimeStopwatchMinutes } from "../../../helpers/timeParsing";
import "./taskList.scss";
import "../cardStack/cardstack.scss";
import { DemoCalendarBlock } from "./HorizontalCalendarDemo";

/**
 * Self-contained, read-only stand-in for CardStackCalendar.
 * Surfaces whichever mock event/scheduled task is currently happening or
 * starting soon - no redux, no click-to-navigate.
 */
function CardStackCalendarDemo({ elements }: { elements: DemoCalendarBlock[] }) {
  const relevantEntry = useMemo(() => {
    const candidates = elements
      .map((element) => ({
        element,
        duration: durationToEvent(element.start, element.end),
      }))
      .filter(({ duration }) => duration <= 0)
      .sort((a, b) => b.duration - a.duration);

    return candidates[0]?.element;
  }, [elements]);

  const isRelevant = useMemo(() => {
    if (!relevantEntry) return false;
    const duration = durationToEvent(relevantEntry.start, relevantEntry.end);
    const hoursUntil = -duration / 1000 / 3600;
    return hoursUntil < 12;
  }, [relevantEntry]);

  if (!isRelevant || !relevantEntry) return <div className="container-cardstack-calendar" />;

  const isActive = eventActive(relevantEntry.start, relevantEntry.end);

  const label = isActive
    ? `Started ${relevantEntry.start.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`
    : `Starts in ${formatTimeStopwatchMinutes(
        (relevantEntry.start.getTime() - Date.now()) / 1000,
      )}`;

  return (
    <div className="container-cardstack-calendar">
      <div className={`event-item ${isActive ? "bg__animated_blue" : ""}`}>
        <SvgImageSwap src={CalendarIcon} className="icon__big color-blue" />
        <div className="task-list-item__wrapper">
          <div className="task-list-item__content">
            <p className="grow big h3 task-list-item__heading">
              {relevantEntry.title}
            </p>
          </div>
          <div className="p_day active">
            <p className="p_small">{label}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardStackCalendarDemo;
